import { injectCpmsBoTariffApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-tariff.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoTariffApi = injectCpmsBoTariffApi(baseApi);

export const {
  useCpmsBoGetTariffQuery,
  useCpmsBoCreateTariffMutation,
  useCpmsBoUpdateTariffMutation,
  useCpmsBoDeleteTariffMutation,
  useCpmsBoGetTariffsPaginatedQuery,
} = cpmsBoTariffApi;
